import React, { useEffect, useState } from "react";
import { getServiceUsersInfo } from "../../services/RegistrationService";

import { ServiceUsersContextProvider } from "../../context/ServiceUsersContext";
import ServiceUsersMobile from "../../components/ServiceUsers/ServiceUsersMobile/ServiceUsersMobile";
import { props } from "cypress/types/bluebird";

interface Props {
  collapsed: boolean;
  match: any;
}

const ManageServiceUsersMobileContainer: React.FC<Props> = ({
  collapsed,
  match,
}) => {
  const [personId, setPersonId] = useState<number>(0);
  const [parentPersonId, setParentPersonId] = useState<number>(0);
  const [personName, setPersonName] = useState<string>("");
  const [type, setType] = useState<string>("");
  useEffect(() => {
    if (match.params.id && match.params.type && match.params.parentId) {
      setPersonId(match.params.id);
      setParentPersonId(match.params.parentId);
      setType(match.params.type);
      handleManageServiceUsersData(match.params.parentId);
    }
  }, [match.params]);

  async function handleManageServiceUsersData(id: number) {
    let data = await getServiceUsersInfo(id);
    let userData = data.filter(
      (x: { personId: number }) => x.personId === Number(match.params.id)
    );
    setPersonName(`${userData[0].firstName} ${userData[0].lastName}`);
  }

  return (
    <ServiceUsersContextProvider>
      <ServiceUsersMobile
        parentPersonId={parentPersonId}
        personId={match.params.id}
        typeOfService={type}
        serviceUserName={personName}
      />
    </ServiceUsersContextProvider>
  );
};
export default ManageServiceUsersMobileContainer;
